/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {setBitcoinDisplayPreference} from '../api'

export const useMutationSetBitcoinDisplayPreference = createReactQueryMutationHook('setBitcoinDisplayPreference', setBitcoinDisplayPreference)
